export const getEndpoint = (msName: string) => `${process.env.API_URL}${msName}/`;
